var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "tile is-ancestor" }, [
      _c("div", { staticClass: "tile" }, [
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("h5", { staticClass: "title is-5" }, [
              _vm._v("Quote Report options"),
            ]),
            _c("div", { staticClass: "field" }, [
              !_vm.innerValue.isAssessmentEnabled
                ? _c(
                    "div",
                    _vm._l(_vm.subQuoteNos, function (quote) {
                      return _c("span", { key: quote.key }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-curve p-smooth p-bigger",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.innerValue.quotePrintOptions
                                      .selectedQuotes,
                                  expression:
                                    "innerValue.quotePrintOptions.selectedQuotes",
                                },
                              ],
                              attrs: {
                                id: `quote${quote.key}`,
                                type: "checkbox",
                                checked: "checked",
                              },
                              domProps: {
                                value: quote,
                                checked: Array.isArray(
                                  _vm.innerValue.quotePrintOptions
                                    .selectedQuotes
                                )
                                  ? _vm._i(
                                      _vm.innerValue.quotePrintOptions
                                        .selectedQuotes,
                                      quote
                                    ) > -1
                                  : _vm.innerValue.quotePrintOptions
                                      .selectedQuotes,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.innerValue.quotePrintOptions
                                        .selectedQuotes,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = quote,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.innerValue.quotePrintOptions,
                                          "selectedQuotes",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.innerValue.quotePrintOptions,
                                          "selectedQuotes",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.innerValue.quotePrintOptions,
                                      "selectedQuotes",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon mdi mdi-check" }),
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    quote.key === 0
                                      ? "Quote"
                                      : `Add ${quote.key}`
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ])
                    }),
                    0
                  )
                : _c(
                    "div",
                    _vm._l(_vm.subQuoteNos, function (assessment) {
                      return _c("span", { key: assessment }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-curve p-smooth p-bigger",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.innerValue.quotePrintOptions
                                      .selectedAssessments,
                                  expression:
                                    "innerValue.quotePrintOptions.selectedAssessments",
                                },
                              ],
                              attrs: {
                                id: `assessment${assessment}`,
                                type: "checkbox",
                                checked: "checked",
                              },
                              domProps: {
                                value: assessment,
                                checked: Array.isArray(
                                  _vm.innerValue.quotePrintOptions
                                    .selectedAssessments
                                )
                                  ? _vm._i(
                                      _vm.innerValue.quotePrintOptions
                                        .selectedAssessments,
                                      assessment
                                    ) > -1
                                  : _vm.innerValue.quotePrintOptions
                                      .selectedAssessments,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.innerValue.quotePrintOptions
                                        .selectedAssessments,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = assessment,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.innerValue.quotePrintOptions,
                                          "selectedAssessments",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.innerValue.quotePrintOptions,
                                          "selectedAssessments",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.innerValue.quotePrintOptions,
                                      "selectedAssessments",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "state p-primary" }, [
                              _c("i", { staticClass: "icon mdi mdi-check" }),
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    assessment === 0
                                      ? "Main"
                                      : `Supp ${assessment}`
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ])
                    }),
                    0
                  ),
            ]),
            _c("div", { staticClass: "is-divider" }),
            _c("div", { staticClass: "columns field" }, [
              _c("div", { staticClass: "column" }, [
                _c(
                  "div",
                  { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quoteTypes.H,
                          expression: "quoteTypes.H",
                        },
                      ],
                      attrs: {
                        id: "hoursDollarQuote",
                        type: "checkbox",
                        value: "H",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.quoteTypes.H)
                          ? _vm._i(_vm.quoteTypes.H, "H") > -1
                          : _vm.quoteTypes.H,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeReportType($event)
                        },
                        change: function ($event) {
                          var $$a = _vm.quoteTypes.H,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "H",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.quoteTypes, "H", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.quoteTypes,
                                  "H",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.quoteTypes, "H", $$c)
                          }
                        },
                      },
                    }),
                    _vm._m(0),
                  ]
                ),
              ]),
              _c("div", { staticClass: "column" }, [
                _c(
                  "div",
                  { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quoteTypes.D,
                          expression: "quoteTypes.D",
                        },
                      ],
                      attrs: {
                        id: "dollarOnlyQuote",
                        type: "checkbox",
                        value: "D",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.quoteTypes.D)
                          ? _vm._i(_vm.quoteTypes.D, "D") > -1
                          : _vm.quoteTypes.D,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeReportType($event)
                        },
                        change: function ($event) {
                          var $$a = _vm.quoteTypes.D,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "D",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.quoteTypes, "D", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.quoteTypes,
                                  "D",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.quoteTypes, "D", $$c)
                          }
                        },
                      },
                    }),
                    _vm._m(1),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "is-divider" }),
            _c("div", { staticClass: "columns field" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.innerValue.quotePrintOptions.itemNumber,
                            expression:
                              "innerValue.quotePrintOptions.itemNumber",
                          },
                        ],
                        attrs: { id: "itemNumber", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.innerValue.quotePrintOptions.itemNumber
                          )
                            ? _vm._i(
                                _vm.innerValue.quotePrintOptions.itemNumber,
                                null
                              ) > -1
                            : _vm.innerValue.quotePrintOptions.itemNumber,
                        },
                        on: {
                          change: function ($event) {
                            var $$a =
                                _vm.innerValue.quotePrintOptions.itemNumber,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.innerValue.quotePrintOptions,
                                    "itemNumber",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.innerValue.quotePrintOptions,
                                    "itemNumber",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.innerValue.quotePrintOptions,
                                "itemNumber",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(2),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.innerValue.quotePrintOptions
                                .individualItemValue,
                            expression:
                              "innerValue.quotePrintOptions.individualItemValue",
                          },
                        ],
                        attrs: { id: "individualItemHours", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.innerValue.quotePrintOptions.individualItemValue
                          )
                            ? _vm._i(
                                _vm.innerValue.quotePrintOptions
                                  .individualItemValue,
                                null
                              ) > -1
                            : _vm.innerValue.quotePrintOptions
                                .individualItemValue,
                        },
                        on: {
                          change: function ($event) {
                            var $$a =
                                _vm.innerValue.quotePrintOptions
                                  .individualItemValue,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.innerValue.quotePrintOptions,
                                    "individualItemValue",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.innerValue.quotePrintOptions,
                                    "individualItemValue",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.innerValue.quotePrintOptions,
                                "individualItemValue",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _c("div", { staticClass: "state p-primary" }, [
                        _c("i", { staticClass: "icon mdi mdi-check" }),
                        _c("label", [
                          _vm._v(
                            "Individual Item " +
                              _vm._s(
                                _vm.innerValue.quotePrintOptions.quoteType ===
                                  "H"
                                  ? "Hours"
                                  : "$"
                              )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.innerValue.quotePrintOptions.partsListPrice,
                            expression:
                              "innerValue.quotePrintOptions.partsListPrice",
                          },
                        ],
                        attrs: { id: "partsListPrice", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.innerValue.quotePrintOptions.partsListPrice
                          )
                            ? _vm._i(
                                _vm.innerValue.quotePrintOptions.partsListPrice,
                                null
                              ) > -1
                            : _vm.innerValue.quotePrintOptions.partsListPrice,
                        },
                        on: {
                          change: function ($event) {
                            var $$a =
                                _vm.innerValue.quotePrintOptions.partsListPrice,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.innerValue.quotePrintOptions,
                                    "partsListPrice",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.innerValue.quotePrintOptions,
                                    "partsListPrice",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.innerValue.quotePrintOptions,
                                "partsListPrice",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(3),
                    ]
                  ),
                ]),
                this.$company.info.countryCode === "MY"
                  ? _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-icon p-curve p-smooth p-bigger",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.innerValue.quotePrintOptions.showPrices,
                                expression:
                                  "innerValue.quotePrintOptions.showPrices",
                              },
                            ],
                            attrs: { id: "showPrices", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.innerValue.quotePrintOptions.showPrices
                              )
                                ? _vm._i(
                                    _vm.innerValue.quotePrintOptions.showPrices,
                                    null
                                  ) > -1
                                : _vm.innerValue.quotePrintOptions.showPrices,
                            },
                            on: {
                              change: function ($event) {
                                var $$a =
                                    _vm.innerValue.quotePrintOptions.showPrices,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.innerValue.quotePrintOptions,
                                        "showPrices",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.innerValue.quotePrintOptions,
                                        "showPrices",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.innerValue.quotePrintOptions,
                                    "showPrices",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _vm._m(4),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "pretty p-default p-round p-bigger p-smooth",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.innerValue.quotePrintOptions.partPrintType,
                            expression:
                              "innerValue.quotePrintOptions.partPrintType",
                          },
                        ],
                        attrs: { type: "radio", name: "afterMarket" },
                        domProps: {
                          value: "A",
                          checked: _vm._q(
                            _vm.innerValue.quotePrintOptions.partPrintType,
                            "A"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.innerValue.quotePrintOptions,
                              "partPrintType",
                              "A"
                            )
                          },
                        },
                      }),
                      _vm._m(5),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "pretty p-default p-round p-bigger p-smooth",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.innerValue.quotePrintOptions.partPrintType,
                            expression:
                              "innerValue.quotePrintOptions.partPrintType",
                          },
                        ],
                        attrs: { type: "radio", name: "parallel" },
                        domProps: {
                          value: "P",
                          checked: _vm._q(
                            _vm.innerValue.quotePrintOptions.partPrintType,
                            "P"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.innerValue.quotePrintOptions,
                              "partPrintType",
                              "P"
                            )
                          },
                        },
                      }),
                      _vm._m(6),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "pretty p-default p-round p-bigger p-smooth",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.innerValue.quotePrintOptions.partPrintType,
                            expression:
                              "innerValue.quotePrintOptions.partPrintType",
                          },
                        ],
                        attrs: { type: "radio", name: "recycledOemParts" },
                        domProps: {
                          value: "R",
                          checked: _vm._q(
                            _vm.innerValue.quotePrintOptions.partPrintType,
                            "R"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.innerValue.quotePrintOptions,
                              "partPrintType",
                              "R"
                            )
                          },
                        },
                      }),
                      _vm._m(7),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "pretty p-default p-round p-bigger p-smooth",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.innerValue.quotePrintOptions.partPrintType,
                            expression:
                              "innerValue.quotePrintOptions.partPrintType",
                          },
                        ],
                        attrs: { type: "radio", name: "parallelOemParts" },
                        domProps: {
                          value: "O",
                          checked: _vm._q(
                            _vm.innerValue.quotePrintOptions.partPrintType,
                            "O"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.innerValue.quotePrintOptions,
                              "partPrintType",
                              "O"
                            )
                          },
                        },
                      }),
                      _vm._m(8),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "tile is-parent is-vertical" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("h5", { staticClass: "title is-5" }, [
              _vm._v("Select additional reports to print"),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.jobCardPrintOpions.jobCardReport,
                        expression:
                          "innerValue.jobCardPrintOpions.jobCardReport",
                      },
                    ],
                    attrs: { id: "jobCard", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.innerValue.jobCardPrintOpions.jobCardReport
                      )
                        ? _vm._i(
                            _vm.innerValue.jobCardPrintOpions.jobCardReport,
                            null
                          ) > -1
                        : _vm.innerValue.jobCardPrintOpions.jobCardReport,
                    },
                    on: {
                      change: function ($event) {
                        var $$a =
                            _vm.innerValue.jobCardPrintOpions.jobCardReport,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.innerValue.jobCardPrintOpions,
                                "jobCardReport",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.innerValue.jobCardPrintOpions,
                                "jobCardReport",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.innerValue.jobCardPrintOpions,
                            "jobCardReport",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._m(9),
                ]
              ),
            ]),
            _vm.innerValue.jobCardPrintOpions.jobCardReport
              ? _c("div", { staticClass: "is-divider" })
              : _vm._e(),
            _vm.innerValue.jobCardPrintOpions.jobCardReport
              ? _c("div", { staticClass: "title is-6" }, [
                  _vm._v("Job Card report options"),
                ])
              : _vm._e(),
            _vm.innerValue.jobCardPrintOpions.jobCardReport
              ? _c("div", { staticClass: "columns is-gapless" }, [
                  _c("div", { staticClass: "column is-narrow" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-default p-round p-bigger p-smooth",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.innerValue.jobCardPrintOpions
                                    .jobCardHourType,
                                expression:
                                  "innerValue.jobCardPrintOpions.jobCardHourType",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              id: "categoryTargetHours",
                              value: "CAT",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.innerValue.jobCardPrintOpions
                                  .jobCardHourType,
                                "CAT"
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.innerValue.jobCardPrintOpions,
                                  "jobCardHourType",
                                  "CAT"
                                )
                              },
                            },
                          }),
                          _vm._m(10),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-default p-round p-bigger p-smooth",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.innerValue.jobCardPrintOpions
                                    .jobCardHourType,
                                expression:
                                  "innerValue.jobCardPrintOpions.jobCardHourType",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              id: "jobCardIndividualItemHours",
                              value: "INDIVIDUAL",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.innerValue.jobCardPrintOpions
                                  .jobCardHourType,
                                "INDIVIDUAL"
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.innerValue.jobCardPrintOpions,
                                  "jobCardHourType",
                                  "INDIVIDUAL"
                                )
                              },
                            },
                          }),
                          _vm._m(11),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-default p-round p-bigger p-smooth",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.innerValue.jobCardPrintOpions
                                    .jobCardHourType,
                                expression:
                                  "innerValue.jobCardPrintOpions.jobCardHourType",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              id: "categoryTargetHours",
                              value: "PRINT",
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.innerValue.jobCardPrintOpions
                                  .jobCardHourType,
                                "PRINT"
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.innerValue.jobCardPrintOpions,
                                  "jobCardHourType",
                                  "PRINT"
                                )
                              },
                            },
                          }),
                          _vm._m(12),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "column is-narrow" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        { staticClass: "control is-narrow" },
                        [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("R & R %"),
                          ]),
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              min: 0,
                              max: 100,
                              symbol: "%",
                              placeholder: "R & R %",
                              "symbol-position": "suffix",
                              precision: 0,
                            },
                            model: {
                              value:
                                _vm.innerValue.jobCardPrintOpions.rrPercent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.innerValue.jobCardPrintOpions,
                                  "rrPercent",
                                  $$v
                                )
                              },
                              expression:
                                "innerValue.jobCardPrintOpions.rrPercent",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Repair %"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "control is-narrow" },
                        [
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              min: 0,
                              max: 100,
                              symbol: "%",
                              placeholder: "Repair %",
                              "symbol-position": "suffix",
                              precision: 0,
                            },
                            model: {
                              value:
                                _vm.innerValue.jobCardPrintOpions.repairPercent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.innerValue.jobCardPrintOpions,
                                  "repairPercent",
                                  $$v
                                )
                              },
                              expression:
                                "innerValue.jobCardPrintOpions.repairPercent",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Paint %"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              min: 0,
                              max: 100,
                              symbol: "%",
                              placeholder: "Paint %",
                              "symbol-position": "suffix",
                              precision: 0,
                            },
                            model: {
                              value:
                                _vm.innerValue.jobCardPrintOpions.paintPercent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.innerValue.jobCardPrintOpions,
                                  "paintPercent",
                                  $$v
                                )
                              },
                              expression:
                                "innerValue.jobCardPrintOpions.paintPercent",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.jobCoverSheet,
                        expression: "innerValue.jobCoverSheet",
                      },
                    ],
                    attrs: { id: "innerValue.jobCoverSheet", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.innerValue.jobCoverSheet)
                        ? _vm._i(_vm.innerValue.jobCoverSheet, null) > -1
                        : _vm.innerValue.jobCoverSheet,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.innerValue.jobCoverSheet,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.innerValue,
                                "jobCoverSheet",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.innerValue,
                                "jobCoverSheet",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.innerValue, "jobCoverSheet", $$c)
                        }
                      },
                    },
                  }),
                  _vm._m(13),
                ]
              ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.supplementarySheet,
                        expression: "innerValue.supplementarySheet",
                      },
                    ],
                    attrs: {
                      id: "innerValue.supplementarySheet",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.innerValue.supplementarySheet)
                        ? _vm._i(_vm.innerValue.supplementarySheet, null) > -1
                        : _vm.innerValue.supplementarySheet,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.innerValue.supplementarySheet,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.innerValue,
                                "supplementarySheet",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.innerValue,
                                "supplementarySheet",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.innerValue, "supplementarySheet", $$c)
                        }
                      },
                    },
                  }),
                  _vm._m(14),
                ]
              ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.finalCheck,
                        expression: "innerValue.finalCheck",
                      },
                    ],
                    attrs: { id: "innerValue.finalCheck", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.innerValue.finalCheck)
                        ? _vm._i(_vm.innerValue.finalCheck, null) > -1
                        : _vm.innerValue.finalCheck,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.innerValue.finalCheck,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.innerValue,
                                "finalCheck",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.innerValue,
                                "finalCheck",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.innerValue, "finalCheck", $$c)
                        }
                      },
                    },
                  }),
                  _vm._m(15),
                ]
              ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.clearanceAdvice,
                        expression: "innerValue.clearanceAdvice",
                      },
                    ],
                    attrs: {
                      id: "innerValue.clearanceAdvice",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.innerValue.clearanceAdvice)
                        ? _vm._i(_vm.innerValue.clearanceAdvice, null) > -1
                        : _vm.innerValue.clearanceAdvice,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.innerValue.clearanceAdvice,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.innerValue,
                                "clearanceAdvice",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.innerValue,
                                "clearanceAdvice",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.innerValue, "clearanceAdvice", $$c)
                        }
                      },
                    },
                  }),
                  _vm._m(16),
                ]
              ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.clearanceCertificate,
                        expression: "innerValue.clearanceCertificate",
                      },
                    ],
                    attrs: {
                      id: "innerValue.clearanceCertificate",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.innerValue.clearanceCertificate
                      )
                        ? _vm._i(_vm.innerValue.clearanceCertificate, null) > -1
                        : _vm.innerValue.clearanceCertificate,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.innerValue.clearanceCertificate,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.innerValue,
                                "clearanceCertificate",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.innerValue,
                                "clearanceCertificate",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.innerValue, "clearanceCertificate", $$c)
                        }
                      },
                    },
                  }),
                  _vm._m(17),
                ]
              ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.authorityNotification,
                        expression: "innerValue.authorityNotification",
                      },
                    ],
                    attrs: {
                      id: "innerValue.authorityNotification",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.innerValue.authorityNotification
                      )
                        ? _vm._i(_vm.innerValue.authorityNotification, null) >
                          -1
                        : _vm.innerValue.authorityNotification,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.innerValue.authorityNotification,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.innerValue,
                                "authorityNotification",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.innerValue,
                                "authorityNotification",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.innerValue, "authorityNotification", $$c)
                        }
                      },
                    },
                  }),
                  _vm._m(18),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Hours Dollar Quote")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Dollar Only Quote")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Item Number")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Parts List Price")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Show Prices")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v('Print "After Market"')]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v('Print "Parallel"')]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v('Print "Recycled OEM Parts"')]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v('Print "Parallel OEM Parts"')]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Job Card")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v("Category Target Hours")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v("Individual Item Hours")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary-o" }, [
      _c("label", [_vm._v("Do not print Hours")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Job Cover Sheet")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Supplementary Sheet")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Final Check")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Clearance Advice")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Clearance Certificate")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Customer Repair & Payment Authority Notification")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }